import StatusCuatro from '../../modules/ctr-r/troubleshooting/Components_Status/Status_four';
import StatusNeighbors from '../../modules/ctr-r/Neighbors/Status';
import NeighborsCrud from '../../modules/ctr-r/Neighbors/Neighbors';
import { useAuth } from '../../modules/auth';
import { useState, useEffect } from 'react';
import { useAppSelector } from '../../../redux/hooks';
import { Routes, Route, NavLink, Navigate, useNavigate } from 'react-router-dom';
import { Spinner } from 'react-bootstrap'; // Importar Spinner para la carga

const Neighborstab: React.FC = () => {
  const Plansus = useAppSelector(state => state.planSlice.plans);
  const ListaPermisosTenant = useAppSelector(state => state.ListPermissionSlice.Permissions);

  const { currentUser } = useAuth();
  const [flag, setflag] = useState<number>();
  const [num, setnum] = useState<number>();
  const [loading, setLoading] = useState(true); // Estado para gestionar la carga
  const navigate = useNavigate();

  // Validación de permisos y redirección con estado de carga
  useEffect(() => {
    const delay = setTimeout(() => {
      if (ListaPermisosTenant.length > 0) {
        setLoading(false); // Detener la carga cuando los permisos estén cargados
        if (!ListaPermisosTenant.includes('CTXR.Neighbor.List')) {
          // Si no tiene permisos para 'CTXR.Neighbor.List', validamos si tiene Home.Status
          if (ListaPermisosTenant.includes('Home.Status')) {
            navigate('/dashboard/status');
          } else {
            // Si no tiene Home.Status, redirigimos a cloudConnectivity
            navigate('/cloudConnectivity');
          }
        }
      }
    }, 1000); // Retraso de 1 segundo

    // Limpiar timeout si el componente se desmonta
    return () => clearTimeout(delay);
  }, [ListaPermisosTenant, navigate]);

  // Establecer flags basados en los permisos del usuario
  useEffect(() => {
    if (currentUser?.ListPermiso?.includes('CTXR.Neighbor.List')) {
      setflag(1);
    } else if (currentUser?.ListPermiso?.includes('CTXR.Neighbor.Status')) {
      setflag(2);
    } else if (!ListaPermisosTenant.includes('CTXR.Neighbor.List')) {
      setflag(1);
    }
  }, [currentUser, ListaPermisosTenant]);

  // Mostrar spinner mientras se cargan los permisos
  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column' }}>
        <Spinner animation="border" role="status" variant="primary">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
        <div  className="text-marino" style={{ marginTop: '20px', fontSize: '18px', color: '#007bff' }}>We are validating your permissions...</div>
      </div>
    );
  }

  return (
    <div className='card'>
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='f-titulo text-marino fs-md'>Neighbors</span>
        </h3>
      </div>
      <ul style={{ marginLeft: '25px', marginRight: '25px' }} className="nav nav-tabs nav-line-tabs mb-5 fs-6">
        {(currentUser?.ListPermiso?.includes('CTXR.Neighbor.List') || !ListaPermisosTenant.includes('CTXR.Neighbor.List')) && (
          <li className="nav-item">
            <NavLink
              className="nav-link"
              to="management"
              onClick={() => (setnum(1), setflag(1))}
            >
              Neighbors Management
            </NavLink>
          </li>
        )}
        {(currentUser?.ListPermiso?.includes('CTXR.Neighbor.Status') || !ListaPermisosTenant.includes('CTXR.Neighbor.Status')) && (
          <li className="nav-item">
            <NavLink
              className="nav-link"
              to="status"
              onClick={() => (setnum(2), setflag(2))}
            >
              Neighbor Status
            </NavLink>
          </li>
        )}
      </ul>
      <div style={{ marginLeft: '25px', marginRight: '25px' }} className="tab-content" id="myTabContent">
        <Routes>
          {(currentUser?.ListPermiso?.includes('CTXR.Neighbor.List') || !ListaPermisosTenant.includes('CTXR.Neighbor.List')) && (
            <Route path="management" element={
              <>
                <NeighborsCrud tab={flag}></NeighborsCrud>
              </>
            } />
          )}
          {(currentUser?.ListPermiso?.includes('CTXR.Neighbor.Status') || !ListaPermisosTenant.includes('CTXR.Neighbor.Status')) && (
            <Route path="status" element={<StatusNeighbors id={flag}></StatusNeighbors>} />
          )}
          {/* Default route */}
          {(currentUser?.ListPermiso?.includes('CTXR.Neighbor.List') || !ListaPermisosTenant.includes('CTXR.Neighbor.List')) ? (
            <Route path="*" element={<Navigate to="management" />} />
          ) : (
            <Route path="*" element={<Navigate to="/CTX-R/Management/neighbors" />} />
          )}
        </Routes>
      </div>
    </div>
  );
}

export { Neighborstab };
